import { slugifyText } from './slugify'

/**
 * Gera um ID de heading estável e SEO-friendly a partir do texto:
 * minúsculas, hífens, sem acentos (NFD + remoção de marcas), alfanumérico.
 * Usa `slugifyText`; garante fallback `secao` se o resultado for vazio.
 */
export function slugifyHeadingId(text: string): string {
  return slugifyText(text) || 'secao'
}

/** Garante IDs únicos quando vários headings geram o mesmo slug. */
export function uniqueHeadingIds(texts: string[]): string[] {
  const used = new Set<string>()
  const out: string[] = []

  for (const t of texts) {
    let base = slugifyHeadingId(t)
    let id = base
    let n = 2
    while (used.has(id)) {
      id = `${base}-${n}`
      n += 1
    }
    used.add(id)
    out.push(id)
  }

  return out
}
